import { ReactNode } from "react";

interface SectionContainerProps {
  title: string;
  children: ReactNode;
  className?: any;
}

export const SectionContainer: React.FC<SectionContainerProps> = ({
  title,
  children,
}) => (
  <section className="w-full flex flex-col items-start border border-gray-300 rounded-lg px-4 mt-4 ">
    <h2 className="text-black text-xl font-bold p-2 rounded mt-2">{title}</h2>
    <div className="w-full">{children}</div>
  </section>
);
export const SectionContainerWithoutBorder: React.FC<SectionContainerProps> = ({
  title,
  children,
  className="px-4",
}) => (
  <section
    className={`w-full flex flex-col items-start   mt-4  ${className}`}
  >
    <h2 className="text-black text-xl font-bold p-2 rounded mt-2">{title}</h2>
    <div className="w-full">{children}</div>
  </section>
);
